import { SearchBox } from "@fluentui/react";
import React from "react";
import styled from "styled-components";

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
} & {
  [key: string]: any;
};

export let NavigationSearch = ({
  value,
  onChange,
  placeholder,
  className,
  ...otherProps
}: Props) => {
  return (
    <SearchBoxContainer className={className} {...otherProps}>
      <StyledSearchBox
        placeholder={placeholder}
        value={value}
        onChange={(_, value) => onChange(value || "")}
      />
    </SearchBoxContainer>
  );
};

const SearchBoxContainer = styled.div`
  .ms-SearchBox {
    background-color: ${(p) => p.theme.palette.white};
    border: 1px solid ${(p) => p.theme.palette.neutralTertiaryAlt};
    border-radius: 2px;
  }
  width: 300px;
`;

const StyledSearchBox = styled(SearchBox)`
  border: 0;
`;
